import { Card } from '@mui/material';
import { DateTime } from 'luxon';
import { selectSelectedTeamMemberId } from 'redux/slices/selectedMemberSlice';
import { useAppSelector } from 'redux/store-hooks';
import SigmaEmbed from '../embeds/sigmaEmbed';

export const MemberDetailsPage = () => {
  const teamMemberId = useAppSelector(selectSelectedTeamMemberId);
  if (!teamMemberId || teamMemberId === 'none') {
    return null;
  }
  return (
    <Card sx={{ flex: 1, height: '100%' }}>
      <SigmaEmbed
        embedKey="memberDetails"
        embedParams={{
          guideId: teamMemberId,
          yearMonth: DateTime.now().toFormat('yyyyMM'),
        }}
        style={{ height: '100%' }}
      />
    </Card>
  );
};
